
export const ApiExtensionPlaceholder = '{extension}';


export const MetaHeaderJsApi = '_jsApi';